import React from 'react';
import { intersperse } from 'utils/array-helper';

import styles from './KeyboardShortcutTooltip.module.scss';

interface Props {
  title?: string;
  shortcut: string;
}

const KeyboardShortcutTooltip: React.FC<Props> = ({ shortcut, title }) => {
  return (
    <div className={styles.tooltip}>
      {!!title && <span className={styles.title}>{title}</span>}
      <span className={styles.shortcut}>
        [
        {intersperse(
          shortcut.split(',').map(singleShortcut => singleShortcut.trim()),
          () => ' or '
        ).join('')}
        ]
      </span>
    </div>
  );
};
export default KeyboardShortcutTooltip;
